var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h1", [_vm._v("Legitimierung")]),
      _vm._v(" "),
      _c(
        "b-container",
        [
          !_vm.valid
            ? _c("div", [_vm._v("Dieser Link ist nicht mehr gültig.")])
            : [
                _vm.success
                  ? _c("div", [
                      _vm._v(
                        "\n\t\t\t\tAusweis erfolgreich hochgeladen, du kannst nun im Prozess fortfahren.\n\t\t\t"
                      )
                    ])
                  : [
                      _c("div", [
                        _vm._v(
                          "\n\t\t\t\t\tHier kannst du deinen Ausweis hochladen. Sobald dies erledigt ist, kannst du im Prozess\n\t\t\t\t\tfortfahren.\n\t\t\t\t"
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "mt-4" },
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "10" } },
                            [
                              _c(
                                "FormGroup",
                                [
                                  _c("FileInput", {
                                    model: {
                                      value: _vm.file,
                                      callback: function($$v) {
                                        _vm.file = $$v
                                      },
                                      expression: "file"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.file
                                ? [
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          label:
                                            "Die hinaufgeladene Datei enthält einen amtlichen Lichtbildausweis von mir persönlich mit einem einem Foto von meinem eigenen Gesicht:",
                                          state: _vm.face !== false,
                                          "invalid-feedback":
                                            "Bitte verwende ein persönliches Ausweisdokument von dir mit einem Foto von deinem Gesicht.",
                                          "feedback-beneath": ""
                                        }
                                      },
                                      [
                                        _c("RadioGroup", {
                                          attrs: { options: _vm.faceOptions },
                                          model: {
                                            value: _vm.face,
                                            callback: function($$v) {
                                              _vm.face = $$v
                                            },
                                            expression: "face"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "mt-3",
                                        attrs: {
                                          label:
                                            "Der Text des Ausweises ist gut leserlich und auf dem Foto ist mein Gesicht klar sichtbar:",
                                          state: _vm.clearness !== false,
                                          "invalid-feedback":
                                            "Bitte lade ein gut leserliches Ausweisdokument hoch  Button mit entsprechender Rückleitung zum Upload.",
                                          "feedback-beneath": ""
                                        }
                                      },
                                      [
                                        _c("RadioGroup", {
                                          attrs: {
                                            options: _vm.clearnessOptions
                                          },
                                          model: {
                                            value: _vm.clearness,
                                            callback: function($$v) {
                                              _vm.clearness = $$v
                                            },
                                            expression: "clearness"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3" },
                                      [
                                        _c("Button", {
                                          attrs: {
                                            text: "Diesen Ausweis hochladen",
                                            disabled:
                                              !_vm.dataValid || _vm.uploading,
                                            loading: _vm.uploading
                                          },
                                          on: { click: _vm.upload }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("b-col", { attrs: { md: "2" } }, [
                            _vm.file
                              ? _c(
                                  "div",
                                  { staticClass: "mt-1" },
                                  [
                                    _c("b-img", {
                                      attrs: { src: _vm.file.base64, fluid: "" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ]
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }